export default __webpack_public_path__ + "static/media/TESTIMONI-RIAMA.2cc10f1f.jpg";